import { render } from "./RequestsReceived.vue?vue&type=template&id=6d8962d0&scoped=true"
import script from "./RequestsReceived.vue?vue&type=script&lang=js"
export * from "./RequestsReceived.vue?vue&type=script&lang=js"

import "./RequestsReceived.vue?vue&type=style&index=0&id=6d8962d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d8962d0"

export default script